import { Model } from 'grapesjs';
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faArrows } from '@fortawesome/pro-solid-svg-icons/faArrows';
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { icon } from '@fortawesome/fontawesome-svg-core';

export function Toolbar(this: Model) {
  this.get;
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const model = this;
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const { em } = this;
  const ppfx = (em && em.getConfig('stylePrefix')) || '';

  if (!model.get('toolbar')) {
    const toolbar = [];

    if (model.collection) {
      toolbar.push({
        label: icon(faArrowUp).html,
        command: 'select-parent',
      });
    }
    if (model.get('draggable')) {
      toolbar.push({
        label: icon(faArrows, { classes: `${ppfx}no-touch-actions` }).html,
        attributes: {
          draggable: true,
        },
        command: 'tlb-move',
      });
    }
    if (model.get('copyable')) {
      toolbar.push({
        label: icon(faClone).html,
        command: 'tlb-clone',
      });
    }
    if (model.get('removable')) {
      toolbar.push({
        label: icon(faTrash).html,
        command: 'tlb-delete',
      });
    }
    model.set('toolbar', toolbar);
  }
}
